import { FunctionComponent } from "react";
import { NEATTData } from "src/utils/types/UserTypes";

interface ILoanTypeDisplayProps {
    loanType: NEATTData['lt'];
}

const LoanTypeDisplay: FunctionComponent<ILoanTypeDisplayProps> = ({ loanType }) => (
    <div className="w-full">
        <p className="mb-3"><span className="font-medium">Seeking Loan:</span> {loanType.loan.seeking}</p>
        {loanType.loan.seeking === 'yes' && (<p className="mb-3"><span className="font-medium">Loan Type:</span> {loanType.loan.type}</p>)}
        {loanType.loan.seeking === 'yes' && (<p className="mb-3"><span className="font-medium">Loan Amount:</span> {loanType.loan.amount}</p>)}
        <p className="mb-3"><span className="font-medium">Open to Alternative Loans:</span> {loanType.openToExploring}</p>
        <p className="mb-3"><span className="font-medium">Open to Government Backed Loans:</span> {loanType.governmentBackedLoans}</p>
        <p className="mb-3"><span className="font-medium">Has Concerns:</span> {loanType.concerns.active}</p>
        {loanType.concerns.active === 'yes' && (<p className="mb-3"><span className="font-medium">Reason for Concern:</span> {loanType.concerns.reason}</p>)}
    </div>
);

export default LoanTypeDisplay